import React, { Fragment } from "react";
import { ShoppingBag, Download, AlertCircle } from "react-feather";

import { useLocation, withRouter } from "react-router";
import { Link } from "react-router-dom";
import store from "store";
import { Bell, } from "react-feather"
import "./notification.css"
// const Notification = (props) => {
var enquiries = store.get("enquiries");


class Notification extends React.Component {
  state = { enquiries: store.get("enquiries"), toggle: false };
  componentDidMount() {
    var self = this;
    document.addEventListener("enquiries", function (e) {
      // Prints "Example of an event"
      enquiries = e.detail.enquiries;
      console.log({ enquiries }, "enquiries");
      // setenquiries(enquiries);
      self.setState({ enquiries });
    });
  }
  render() {
    const { enquiries } = this.state;
    return (
      <Fragment>
        <div className="notification-dropdown">
          <div className="notification-dropdown-button">
            <Bell style={{ color: "#4466f2", width: "18px", height: "18px" }} />
          </div>
          <ul className="notification-dropdown-content">
            <li>Enquiries</li>
            <li
              className="txt-dark"
              onClick={() => {
                this.props.history.push("/enquiries/all");
              }}
            >
              <Link to="/enquiries/all">All</Link> Enquiries
            </li>
          </ul>
        </div>
      </Fragment>



      // <Fragment>
      //   <div>
      //     <ul className="notification-dropdown onhover-show-div p-0">
      //       <li>Enquiries </li>
      //       {(enquiries || []).length > 0 &&
      //         enquiries.map((item) => {
      //           return (
      //             <li>
      //               <div className="media">
      //                 <div className="media-body">
      //                   <h6 className="mt-0">
      //                     <span>
      //                       <ShoppingBag />
      //                     </span>
      //                     {`${item.quantity} ${
      //                       item.productId ? item.productId.name : ""
      //                     } ${item.quantity > 1 ? "enquiries" : "enquiry"}.`}
      //                   </h6>
      //                   <p className="mb-0">
      //                     {item.clientId
      //                       ? `Client Name: ${item.clientId.name}`
      //                       : ""}
      //                   </p>
      //                 </div>
      //               </div>
      //             </li>
      //           );
      //         })}{" "}
      //       <li
      //         className="txt-dark"
      //         onClick={() => {
      //           this.props.history.push("/enquiries/all");
      //         }}
      //       >
      //         <Link to="/enquiries/all">All</Link> Enquiries
      //       </li>
      //     </ul>
      //   </div>
      // </Fragment>
    );
  }
}

export default withRouter(Notification);
